import { ref, computed} from 'vue';
import { defineStore } from 'pinia';
import { criarQuestoesIA } from '@/api/criarQuestoesIA';
import {carregarDisciplinas} from '@/api/fetchDisciplinas';
import { useStore as useVuexStore } from 'vuex';
import { carregarModelosQuestoes, carregarNiveisComplexidade, salvarQuestoesConsumoApi } from '@/api/fetchQuestoes';


export const useCriarQuestoesStore = defineStore('criarQuestoes', () => {
    const user = ref(null);
    const vuexStore = useVuexStore();
    user.value = vuexStore.state.userSession.user;
    const idUsuario = user.value.idU;
    const carregandoDados = ref(false);
    const modelosQuestoes = ref([]);
    const niveisComplexidade = ref([]);
    carregarDadosIniciais();
    // controla o estado de loading do botão de criar questão
    const btnCriarQuestaoLoading = ref(false);
    
    // controla se as opções estão corretas e habilita o botão de criar questão
    const opcoesValidas = ref(false);
    const menssagemErroInline = ref(false);
    // controla os tabs na parte superir da interface que definem o tipode de dado de entrada
    const fonteDadosParaQuestao = ref(0);
    // salva o texto digitado pelo usuário
    const topicoDigitado = ref('');
    // salva os subtópicos sugeridos pela IA
    const subtopicosSugeridos = ref([]);
    // salva os subtópicos selecionados pelo usuário
    const subtopicosSelecionados = computed(() => subtopicosSugeridos.value.filter(subtopico => subtopico.status));
    // salva o texto digitado pelo usuário quando ele escolhe o modo Texto
    const textoDigitado = ref(`A razão pela qual o homem é um animal político em grau mais elevado do que as abelhas ou qualquer outro animal, é clara: a natureza, como dissemos, não faz nada em vão, e o homem é o único animal que tem palavra (logos); —a voz (fone) expressa a dor e o prazer, e os animais também possuem, já que sua natureza vai até aí— a possibilidade de sentir dor e o prazer e expressá-los entre si. A palavra, porém, está destinada a manifestar o útil e o nocivo e, em consequência, o justo e o injusto. E esta é a característica do homem diante dos demais animais: — possuir, só ele, o sentido do bem e do mal, do justo e do injusto, etc. É a comunidade dessas coisas que faz a família e a cidade. (Aristóteles, 1982, I, 2, 1253 a, 7-12).`);
    // salva um segundo texto digitado quando a quesão pede algum tipo de comparação entre ideias
    const textoDigitadoComparar = ref('');
    // controla o tipo de pergunta selecionado (1 = multipla escolha, 2 = dissertativa)
    const tipoPerguntaSelecionada = ref(1);
    const disciplinas = ref([])
    //controla a disciplina que foi selecionada
    const disciplinaSelecionada = ref(user.value.disciplina)
    // controla a dificuldade da questão
    const dificuldadeSelecionada = ref(1);
    // controla o nivel de leitura da questão
    const nivelLeituraSelecionada = ref(1);
    // controla a habilidade, estilo ou estrutura da questão
    const modeloQuestaoSelecionado = ref({
        "id": 1,
        "created_at": "2024-05-16T19:26:36.706485+00:00",
        "titulo": "Aplicar conceitos em um contexto",
        "descricao": "A questão apresenta um contexto realista onde é necessário aplicar conhecimentos teóricos para resolver problemas práticos.",
        "prompt": "Nelas, os estudantes devem aplicar esses conhecimentos em situações realistas. Para criar contextos de aplicação, pense em situações reais, fora do mundo escolar, nas quais os estudantes poderiam usar os conhecimentos para resolver um problema. Acrescente detalhes a esses cenários para torná-los mais realistas. Em seguida, proponha uma pergunta.",
        "prompt_multipla_escolha": '',
        "nivel_complexidade": 3,
        "fonte_dados": 0,
        "tipo_questao": 0,
        "tamanho_maximo_texto": 0,
        "numeros_textos": null,
        "formato_JSON": 1
    });
    const numeroQuestoes = ref(2);
    // lista das questões geradas pela IA ou criadas pelo usuário
    const questoes = ref([

    ]);

    const questao = ref({
        texto: "",
        pergunta: "",
        a: "",
        b: "",
        c: "",
        d: "",
        gabarito: ""
    });

   
    const nomeDisciplinaSelecionada = computed(() => {
        let disciplina = disciplinas.value.find(disciplina => disciplina.id == disciplinaSelecionada.value);
        return disciplina.nome.toLowerCase();
    })

    async function carregarDadosIniciais(){
        carregandoDados.value = true;
        let modelos = await carregarModelosQuestoes();
        if(modelos.error){
            console.log(error.message);
            return
        }

        let niveis = await carregarNiveisComplexidade();
        if(niveis.error){
            console.log(error.message);
            return
        }

        disciplinas.value = await carregarDisciplinas();

        modelosQuestoes.value = modelos.data;
        niveisComplexidade.value = niveis.data;
        modeloQuestaoSelecionado.value = modelosQuestoes.value[0];
        carregandoDados.value = false;
    }   

    

    function validarCriarQuestoes() {
        if(fonteDadosParaQuestao.value == 0){
            if(topicoDigitado.value.trim() === ''){
                opcoesValidas.value = false;
                menssagemErroInline.value = true;
            }else{
                opcoesValidas.value = true;
                menssagemErroInline.value = false;
            }
        }
        if(fonteDadosParaQuestao.value == 1 && modeloQuestaoSelecionado.value.numeros_textos == 1){
            if (textoDigitado.value.trim() === '' || textoDigitado.value.trim().length > modeloQuestaoSelecionado.value.tamanho_maximo_texto){
                opcoesValidas.value = false;
                menssagemErroInline.value = true;
            } else {
                opcoesValidas.value = true;
                menssagemErroInline.value = false;
            }
        } 
        
        if (fonteDadosParaQuestao.value == 1 && modeloQuestaoSelecionado.value.numeros_textos == 2) {
            if (textoDigitado.value.trim() === '' || textoDigitado.value.trim().length > modeloQuestaoSelecionado.value.tamanho_maximo_texto || textoDigitadoComparar.value.trim() === '' || textoDigitadoComparar.value.trim().length > modeloQuestaoSelecionado.value.tamanho_maximo_texto) {
                opcoesValidas.value = false;
                menssagemErroInline.value = true;
            } else {
                opcoesValidas.value = true;
                menssagemErroInline.value = false;
            }
        } 


        if(opcoesValidas.value) {
            criarQuestoes();
        }
    }

    async function criarQuestoes(){
        btnCriarQuestaoLoading.value = true;
       
        let user = '';
        // prompt para questões a partir de tópicos
        if(fonteDadosParaQuestao.value == 0){
            user = `Sou professor de ${nomeDisciplinaSelecionada.value} de estudantes de ensino médio e estou criando questões sobre ${topicoDigitado.value}`;
            if (subtopicosSelecionados.value.length > 0) {
                user += ` abordando os seguintes subtópicos: ${subtopicosSelecionados.value.map(subtopico => subtopico.texto).join(', ').toLowerCase()}`;
            }
            user += `. `;
        }
       

        // prompt para questões a partir de textos
        if(fonteDadosParaQuestao.value == 1){
            user = `Sou professor de ${nomeDisciplinaSelecionada.value} de estudantes de ensino médio e estou criando questões sobre o texto dentro de [[]].`;
        }

        user += `Crie ${numeroQuestoes.value} questões ${tipoPerguntaSelecionada.value == 1 ? 'de múltipla escolha, com alternativas com aproximadamente o mesmo número de palavras' : 'dissertativas'}. `;

        // define características gerais das alternativas
        user += `${modeloQuestaoSelecionado.value.prompt} `;
        console.log(modeloQuestaoSelecionado.value)
        if(modeloQuestaoSelecionado.value.prompt_multipla_escolha !== null && tipoPerguntaSelecionada.value == 1){
            user += `${modeloQuestaoSelecionado.value.prompt_multipla_escolha} `;
        }

        // prompt para questões a partir de textos
        if (fonteDadosParaQuestao.value == 1) {
            user += ` [[${textoDigitado.value}]].`;
        }

        // define a estrutura dos dados retornados
        let system = 'Os conceitos são 3 tags separadas por vírgula para cada questão. As tags começam com letra maiúscula e envolvem tópicos do currículo da disciplina  em questão. Retorne os dados em formato JSON com a seguinte estrutura questoes: [';
        if(tipoPerguntaSelecionada.value == 1){
            if(modeloQuestaoSelecionado.value.formato_JSON == 2) {
                system += '{conceitos: "", "pergunta": "", "a": "", "b": "", "c": "", "d": "", "gabarito": ""}';
            }else{
                system += '{conceitos: "", "texto": "", "pergunta": "", "a": "", "b": "", "c": "", "d": "", "gabarito": ""}';
            }
        }else{
            if (modeloQuestaoSelecionado.value.formato_JSON == 2) {
                system += '{conceitos: "", "pergunta": ""}';
            }else{
                system += '{conceitos: "", "texto":"", "pergunta": ""}';
            }
        }
        system +=']';
        
        console.log(user + system)

        const {content, usage} = await criarQuestoesIA(user, system);
        

        btnCriarQuestaoLoading.value = false;


        if (content) {
            const parsedResult = JSON.parse(content);
            salvarQuestoesConsumoApi(parsedResult.questoes.length, usage.total_tokens, modeloQuestaoSelecionado.value.id);

            let conceitos = topicoDigitado.value;
            if(subtopicosSelecionados.value.length > 0){
                conceitos += `, ${subtopicosSelecionados.value.map(subtopico => subtopico.texto).join(', ')}`; 
            }
            parsedResult.questoes.forEach(item => {
                let questao = { tipo: tipoPerguntaSelecionada.value, disciplina: disciplinaSelecionada.value, nivel_complexidade: modeloQuestaoSelecionado.value.nivel_complexidade, proprietario: idUsuario,  ...item};
                if([15, 16, 17, 20, 18].includes(modeloQuestaoSelecionado.value.id)){
                    questao.texto = textoDigitado.value;
                }
                let questaoComMetadados = { conceitos: conceitos, ...questao};
                questoes.value.push(questao);
            });

        }

        console.log(questoes.value)
        
    }



    return { carregandoDados, numeroQuestoes, modelosQuestoes, niveisComplexidade, btnCriarQuestaoLoading, disciplinaSelecionada, fonteDadosParaQuestao, topicoDigitado, subtopicosSugeridos, textoDigitado, menssagemErroInline, textoDigitadoComparar, tipoPerguntaSelecionada, dificuldadeSelecionada, nivelLeituraSelecionada, modeloQuestaoSelecionado, opcoesValidas, prompt, questoes, questao, idUsuario, validarCriarQuestoes, criarQuestoes }
})
